// tslint:disable no-string-literal
import { Inject, Injectable } from '@angular/core';
import { AbstractMessageCommand } from 'flux-connection';
import {
    Command,
    CommandError,
    CommandInterfaces,
    StateService,
} from 'flux-core';
import { DataStore } from 'flux-store';
import { UserModel } from '../model/user.mdl';
import { take, map, tap } from 'rxjs/operators';
import { from, Observable } from 'rxjs';

/**
 * This command insert or update user
 * Upgrade dialog seen data
 * @since   2025-08-29
 * @author  Sajeeva
 */
@Injectable()
@Command()
export class UpdateUserSeenUpgradeDialog extends AbstractMessageCommand {

    public static get dataDefinition(): {} {
        return {
            upgradeDialogType: true,
        };
    }

    public static get implements(): Array<CommandInterfaces> {
        return [ 'IMessageCommand', 'IUserCommand' ];
    }

    constructor(
        protected dataStore: DataStore,
        @Inject( StateService ) protected state: StateService<any, any>,
    ) {
        super() /* istanbul ignore next */;
    }

    /**
     * Preserve previous data to revert in case of error.
     */
    public prepareData() {
        this.previousData = {};
        const modelStore = this.dataStore.getModelStore( UserModel );
        return modelStore.findOne({ id: this.state.get( 'CurrentUser' ) }).pipe(
            take( 1 ),
            map( user => ( user?.seenUpgradeDialogs ? user.seenUpgradeDialogs : undefined )),
            tap( upgradeDialogType => {
                this.previousData.upgradeDialogType = upgradeDialogType;
            }),
        );
    }

    /**
     * execute
     */
    public execute(): Observable<any> {
        const modelStore = this.dataStore.getModelStore( UserModel );
        const setter = { $set: {}};
        const prevIds = this.previousData.upgradeDialogType || {};
        const count = (prevIds[this.data.upgradeDialogType] ?? 0) + 1;
        setter.$set['seenUpgradeDialogs'] = { ...prevIds, [this.data.upgradeDialogType]: count };
        return from(
            modelStore.update(
                {
                    id: this.state.get( 'CurrentUser' ),
                },
                setter,
            ).catch(() => {}),
        );
    }

    /**
     * onError
     */
    public onError( err: CommandError ): any {
        const modelStore = this.dataStore.getModelStore( UserModel );
        const setter = { $set: {}};
        setter.$set['seenUpgradeDialogs'] = this.previousData.upgradeDialogType;
        return from(
            modelStore.update({ id: this.state.get( 'CurrentUser' ) }, setter ),
        );
    }
}

Object.defineProperty( UpdateUserSeenUpgradeDialog, 'name', {
    value: 'UpdateUserSeenUpgradeDialog',
});
